

































































































import {Vue, Component, Prop, Watch} from 'vue-property-decorator'
import {mapState, mapActions} from 'vuex'
import type {InterviewQuestion as InterviewQuestionType} from '@/models'
import FancyTextArea from '@/components/FancyTextArea.vue'

@Component({
  components: {FancyTextArea,}
})
export default class InterviewQuestion extends Vue {
  @Prop() question!: InterviewQuestionType
  @Prop({default: ''}) initialAnswer!: string

  answer = ''

  get title(): string {
    return this.question.question
  }

  answerQuestion() {
    this.$emit('answer-question', {question: this.question, answer: this.answer})
  }

  /** Update current answer if initial answer changes.
   * This is used when a project is loaded.
   * This callback is also called any time the answer is updated by the user,
   * so we check that it's not already the current answer to avoid infinite
   * loops.
   */
  @Watch('initialAnswer')
  onAnswerUpdated(newVal: string, oldVal: string) {
    // Vue.$log.debug('Initial answer updated: ', newVal, 'current answer:', this.answer)
    if (newVal !== this.answer) this.answer = newVal
  }

  mounted() {
    // Preload answer from prop
    this.answer = this.initialAnswer
  }
}
